import {Tab, Tabs} from 'react-bootstrap'
import {DocumentTrayCustom1} from './DocumentTrayCustom1'
import {DocumentTrayCustom2} from './DocumentTrayCustom2'
import {UnitByRoleTab} from './UnitByRoleTab'

const DocumentTrayTabs = () => {
  return (
    <>
      <Tabs defaultActiveKey='company' className='mb-3'>
        <Tab eventKey='company' title='Asignacion Empresa'>
          <DocumentTrayCustom1 />
        </Tab>
        <Tab eventKey='unit' title='Asignacion Unidad'>
          <DocumentTrayCustom2 />
        </Tab>
        <Tab eventKey='unit-rol' title='Asignacion unidad/perfil'>
          <UnitByRoleTab />
        </Tab>
      </Tabs>
    </>
  )
}

export {DocumentTrayTabs}
